const texts = {
    "pickup-date.show_more_dates": {
        EN: "Show more dates",
        DA: "Vis flere datoer",
        DE: "Mehr Daten anzeigen",
        NL: "Toon meer datums",
        FR: "Afficher plus de dates",
        IT: "Mostra più date",
        ES: "Mostrar más fechas",
        PT: "Mostrar mais datas",
        FI: "Näytä lisää päivämääriä",
        SV: "Visa fler datum",
        NO: "Vis flere datoer",
    },
    "pickup-date.next-back.error_text": {
        EN: "You have to select a shipping method",
        DA: "Du skal vælge en forsendelsesmetode",
        DE: "Sie müssen eine Versandmethode auswählen",
        NL: "Je moet een verzendmethode selecteren",
        FR: "Vous devez sélectionner une méthode d'expédition",
        IT: "Devi selezionare un metodo di spedizione",
        ES: "Debes seleccionar un método de envío",
        PT: "Você deve selecionar um método de envio",
        FI: "Sinun täytyy valita palautustapa",
        SV: "Du måste välja en fraktmetod",
        NO: "Du må velge en fraktmetode",
    },
    "printer-required": {
        EN: "Printer required",
        DA: "Printer påkrævet",
        DE: "Drucker erforderlich",
        NL: "Printer vereist",
        FR: "Imprimante requise",
        IT: "Stampante richiesta",
        ES: "Impresora requerida",
        PT: "Impressora necessária",
        FI: "Tulostin vaaditaan",
        SV: "Skrivare krävs",
        NO: "Skriver kreves",
    },
};
export default texts;
